import { ServiceRoute } from "../../base/service-route";
import { CoreService } from "../../base/core";
import { Injectable } from "@angular/core";
import { CommonHttpOption } from "../../base/common-http-option";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ProvinceService {
  constructor(private core: CoreService) {}

  GetList(page: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.provinces.list,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }
}
